<template>
    <div class="row">
        <div class="col-12" v-if="isInitialized">
            <tabs ref="tab-calls" type="info" @activate-tab="activateTab" square>
                <tab-pane :id="'calls_' + call.id" :label="call.title" v-for="call in calls" v-bind:key="call.id">
                    <div class="row d-flex">
                        <div class="col-lg-3" v-for="(proposal) in proposals" :key="proposal.id">
                            <card>
                                <template slot="header">
                                    <h3 class="card-title">{{ call.description }}</h3>
                                    <h4 class="card-title">{{ proposal.reference }}</h4>
                                </template>
                                <div>
                                    <router-link :to="{ name: 'Edit Monitoring', params: { callId: call.id, proposalId: proposal.id }}">
                                        <base-button type="primary" size="lg" simple>VIEW</base-button>
                                    </router-link>
                                </div>
                            </card>
                        </div>
                    </div>
                </tab-pane>
            </tabs>
        </div>
    </div>
</template>
<script>
    import {MonitoringService, CallService, ExportService} from '@/services';
    import {TabPane, Tabs} from 'src/components';
    import {Select, Option} from 'element-ui';

    export default
    {
        components:
        {
            TabPane,
            Tabs,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data()
        {
            return {
                isInitialized: false,
                calls: [],
                proposals: [],
                currentCallId: 0,
            }
        },
        async beforeCreate()
        {
            const vm = this;
            const loader = vm.$loading.show();

            await CallService.all().then((response) =>
            {
                vm.calls = response.data;

                if (vm.currentCallId === 0)
                {
                    vm.currentCallId = vm.calls[0].id;
                }
            });

            await vm.getProposals();

            vm.isInitialized = true;

            loader.hide();
        },
        methods:
        {
            async getProposals()
            {
                const vm = this;
                const loader = vm.$loading.show();
                const response = await MonitoringService.getAwardedProposals(
                {
                    call_id: vm.currentCallId,
                });

                if (response)
                {
                    vm.proposals = response.data;
                }

                loader.hide();
            },
            activateTab(ev)
            {
                const vm = this;

                vm.currentCallId = +ev.id.replace('calls_', '');

                vm.getProposals();
            },
        },
    };
</script>
<style lang="scss">
    .filters-holder
    {
        position: absolute;
        right: 0;
        z-index: 10;
    }
</style>
